import React from "react";
import { Route, Navigate } from "react-router-dom";
import { isAuthenticated } from "../services/account.service";
import Loader from "../common/loader";
import NotFoundPage from "../components/errors/404";
import { ROLES } from "../constants/general.constant";
import EmployeeProfile from "../components/employee/profile/employeeProfile";
import Customers from "../components/common/customerDetails";
import Leads from "../components/common/leads";
import CustomerProfile from "../components/common/customerProfile/customerProfile";
import Bankers from "../components/common/bankerDetails";
import MainLayout from "../layout/mainLayout";
import {useAuth} from "../hook/userRoleHook";
import DealsPage from "../components/customers/deals";
import InactiveDealsPage from "../components/customers/inactiveDeals";
import Notifications from "../components/customers/notifications";
import TaskManager from "../components/business/tasks/TaskManager";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { role, loading, redirectionUrl, isLoginPage } = useAuth();

  if (!isAuthenticated() && !isLoginPage) {
    return <Navigate to={redirectionUrl} replace />;
  }

  if (loading) return <Loader />;

  if (role !== ROLES.EMPLOYEE) return <NotFoundPage />;

  return <>{children}</>;
};

const WithLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ProtectedRoute>
    <MainLayout>{children}</MainLayout>
  </ProtectedRoute>
);

const WithoutLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ProtectedRoute>{children}</ProtectedRoute>
);

const employeeRoutesConfig = [
  { key: "customers", path: "/employee/customers", element: <Customers />, layout: "with" },
  { key: "profile", path: "/employee/profile", element: <EmployeeProfile />, layout: "with" },
  { key: "leads", path: "/employee/leads", element: <Leads />, layout: "with" },
  { key: "customer-profile", path: "/employee/customers/:customerId", element: <CustomerProfile />, layout: "without" },
  { key: "bankers", path: "/employee/bankers", element: <Bankers />, layout: "with" },
  { key: "notifications", path: "/employee/notifications", element: <Notifications />, layout: "with" },
  { key: "tasks", path: "/employee/tasks", element: <TaskManager />, layout: "with" },
  { key: "deals", path: "/employee/deals", element: <DealsPage />, layout: "with" },
  { key: "inactive-deals", path: "/employee/inactive-deals", element: <InactiveDealsPage />, layout: "with" },
];

const EmployeeRoutes = employeeRoutesConfig.map(({ key, path, element, layout }) => (
  <Route
    key={key}
    path={path}
    element={layout === "with" ? <WithLayout>{element}</WithLayout> : <WithoutLayout>{element}</WithoutLayout>}
  />
));

export default EmployeeRoutes;
